import { useEffect, useState } from "react";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IPanelRazonEditar } from "./PanelRazonEditar";
import { IRazonEdit } from "../../../../../Interfaces/auxiliar/IRazon";
import { RazonService } from "../../../../../services/auxiliar/RazonService";
import { IComboBoxOption } from "@fluentui/react";
import { EstadoEquipoService } from "../../../../../services/auxiliar/estadoEquipoService";
import { CategoriaRazonService } from "../../../../../services/auxiliar/CategoriaRazonService";
import { Ifilter } from "../../../../../Interfaces/filter";

export const UseRazonPanelEditar=(props:IPanelRazonEditar)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const [estados,setEstados]=useState<IComboBoxOption[]>([])
    const [categorias,setCategorias]=useState<IComboBoxOption[]>([])
    const [filterEstado, setfilterEstado] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const initial:IRazonEdit={
        codigo: "",
        descripcion: "",
        estadoId: "",
        razonId: ""
    }
     const reset=()=>{
         setMensaje("")
         setRequest(initial)
         setStatus(0)
         props.onDismiss()
     }
     useEffect(()=>{
        if(props.isOpen){
            getEstados()
            getCategorias()
        }
    },[props.isOpen])
     const getEstados=()=>{
        EstadoEquipoService.ListarEstado(filterEstado).then((res)=>{
            setEstados(res.data)
        }).catch((e)=>{})
    }
    const getCategorias=()=>{
        const fil:Ifilter={
            skip: 0,
            take: 10
        }
        CategoriaRazonService.ComboCategoria(fil).then((res)=>{
            setCategorias(res.data)
        }).catch((e)=>{})
    }
     useEffect(()=>{
        if(props.isOpen){
          setRequest({...request,codigo:props.item.codigo,descripcion:props.item.descripcion,
            estadoId:props.item.estadoId,razonId:props.item.razonId,categoriaId:props.item.categoriaId})
          }
      },[props.isOpen])
     
     const putEditarRazon=()=>{
        setLoading(true)
        RazonService.UpdateRazon(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
     const [request,setRequest]=useState<IRazonEdit>(initial)
     return {request,setRequest,putEditarRazon,loading,reset,mensaje,status,estados,categorias}






}